import { format } from 'date-fns'
import {
  ATTENDANCE_FLOW,
  GetAuthorizationData,
  GetAuthorizationDataRaw,
  OBSERVATION,
} from './GetAuthorizationData.types'

export class GetAuthorizationDataMapper {
  private static guideNotFound(data: GetAuthorizationDataRaw): boolean {
    return data.observacao === OBSERVATION.NOT_FOUND
  }

  private static isWithoutGuide(data: GetAuthorizationDataRaw): boolean {
    return data.fluxo_atendimento === ATTENDANCE_FLOW.WITHOUT_GUIDE
  }

  private static formattedRequestDateTime(
    data: GetAuthorizationDataRaw,
  ): string | undefined {
    if (!data.dados_autorizacao?.data_solicitacao) {
      return '-'
    }

    return format(
      new Date(data.dados_autorizacao.data_solicitacao),
      "dd/MM/yyyy 'às' HH:mm:ss",
    )
  }

  static toDomain(data: GetAuthorizationDataRaw): GetAuthorizationData {
    return {
      isAuthorized: data.autorizado,
      status: data.status,
      cid: data.cid,
      isExecuted: data.executado,
      token: data.token,
      observation: data.observacao,
      codeGloss: data.codigo_glosa,
      messageGloss: data.mensagem_glosa,
      attendanceFlow: data.fluxo_atendimento,
      authorizationData: {
        providerGuideNumber: data.dados_autorizacao?.numero_guia_prestador,
        operatorGuideNumber: data.dados_autorizacao?.numero_guia_operadora,
        requestDateTime: data.dados_autorizacao?.data_solicitacao,
        authorizationDate: data.dados_autorizacao?.data_autorizacao,
        passwordValidityDate: data.dados_autorizacao?.data_validade_senha,
        requestedQuantity: data.dados_autorizacao?.quantidade_solicitada,
        authorizedQuantity: data.dados_autorizacao?.quantidade_autorizada,
        usedQuantity: data.dados_autorizacao?.quantidade_utilizada,
        procedureCode: data.dados_autorizacao?.codigo_procedimento,
        procedureDescription: data.dados_autorizacao?.descricao_procedimento,
        cardNumber: data.dados_autorizacao?.numero_carteirinha,
      },
      ansRecord: data.registro_ans,
      guideNotFound: GetAuthorizationDataMapper.guideNotFound(data),
      isWithoutGuide: GetAuthorizationDataMapper.isWithoutGuide(data),
      formattedRequestDateTime:
        GetAuthorizationDataMapper.formattedRequestDateTime(data),
    }
  }
}
